export default __webpack_public_path__ + "static/media/Ellipse 138.ec00d7de.svg";